export enum ColorTheme {
  DARK = 'dark',
  LIGHT = 'light',
}
